import classNames from "classnames";
import { Box, Text, theme } from "@ovou-inc/ovou-ui";
import { Icon } from "components";
import { BoxProps } from "@chakra-ui/react";
import { PropsWithChildren } from "react";

interface IMsgBoxProps extends Partial<BoxProps>, PropsWithChildren {
  type?: "info" | "error";
  iconName?: string;
  className?: string;
}

export function MessageBox({
  type = "info",
  iconName,
  className,
  children,
  ...props
}: IMsgBoxProps) {
  return (
    <Box
      className={classNames(className, {
        "bg-custom-red-200": type === "error",
      })}
      display="flex"
      alignItems="center"
      gap={4}
      p={4}
      borderRadius="lg"
      bg={type === "info" ? theme.palette.ui.greys.grey5 : undefined}
      color={theme.palette.ui.states[type]}
      {...(props as any)}
    >
      {iconName && (
        <Box minWidth="24px">
          <Icon name={iconName} width="24px" height="24px" />
        </Box>
      )}
      <Text
        fontSize="14px"
        fontWeight={400}
        lineHeight={1.5}
        color={theme.palette.ui.blackShades.black}
      >
        {children}
      </Text>
    </Box>
  );
}
